import React from 'react';
import { Link } from 'react-router';
import { FormattedDate } from 'react-intl';

import { Card } from 'material-ui/Card';
import { ListItem } from 'material-ui/List';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';

import { DateStyles } from '../../constants/CentricConstants';

const style = {

    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
        margin: '0',
        padding: '0',
    }
};


const ResourceCard = (props) => {
    const infoLink = `/dashboard/module/${props.id}`;

    const listItemProps = {
        key: props.id,
        style: style.listItem,
        primaryText: <Link to={infoLink} className="primaryText">{props.name}</Link>,
        secondaryTextLines: 1,
    };

    // let description = (props.type);
    // if (props.mediaId) {
    //     description = (props.mediaName)
    // }

    const released = new Date(props.validFrom);

    let flags = [];
    if (props.visibility === 'private') {
        flags.push(<span key="a" className="flag-text">private</span>);
    }

    listItemProps.secondaryText = (
        <Link to={infoLink} className="secondaryText">
            <em>{props.code} - <FormattedDate {...DateStyles.long} value={released} /></em>
        </Link>
    );

    let colour = 'rgb(35, 151, 190)';
    let avatarIcon = (<LibraryIcon style={style.icon} color={colour}/>);

    return (
        <Card className="cent-card cent-card-list-item" key={props.id}>
            <ListItem {...listItemProps} style={style.listItem}
                leftAvatar={<Link to={infoLink}>{avatarIcon}</Link>}
            />
        </Card>
    );
};

export default ResourceCard;
